import Resources from '../helpers/resources';
import {AppContext} from '../types';
import {
    ChangeRequest,
    SearchRequest,
    SchoolAcademicYearPutApi,
    SchoolAcademicYearsSearchApi,
    SearchRequestParams
} from './types';

export const schoolAcademicYearsSearch: SchoolAcademicYearsSearchApi =
    async (request: SearchRequest, params: SearchRequestParams) => {
        return Resources.schoolAcademicYearsSearch.post()
            .withBody(request)
            .withParams(params)
            .send();
    };

export const schoolAcademicYearsPut: SchoolAcademicYearPutApi =
    async (input: ChangeRequest) => {
        return Resources.schoolAcademicYearsPut.put()
            .withBody(input)
            .send();
    };

export const api: AppContext['api'] = {
    schoolAcademicYearsPut,
    schoolAcademicYearsSearch
};
